export function isLocalGridCandidate(layer, targetLayer = null) {
  return !!layer &&
    layer !== targetLayer &&
    layer.kind === 'vector' &&
    layer.sourceCrsStatus !== 'resolved' &&
    !layer.sourceCrs;
}

export function sameGridCandidates(layers, targetLayer = null) {
  return (layers || []).filter(layer =>
    isLocalGridCandidate(layer, targetLayer)
  );
}

export function sameGridStatusLabel(layer) {
  const layerName = layer?.result?.name || layer?.name || '';
  const anchorName = layer?.localGridName || '';
  return anchorName && layerName !== anchorName
    ? `same local grid as ${anchorName}`
    : 'shared local grid';
}

function finiteBounds(bounds) {
  return !!bounds && [
    bounds.minX,
    bounds.minY,
    bounds.maxX,
    bounds.maxY
  ].every(value => Number.isFinite(Number(value)));
}

export function canAutoResolveUtmLikeLayer(
  layer,
  referenceBounds,
  projectCrs
) {
  if (
    !layer ||
    layer.kind !== 'vector' ||
    layer.sourceCrsStatus === 'resolved' ||
    layer.sourceCrs ||
    layer.coordinatePattern !== 'utm-like' ||
    projectCrs?.type !== 'utm'
  ) {
    return false;
  }

  const candidateBounds =
    layer.result?.sourceBounds ||
    layer.result?.bounds;

  if (!finiteBounds(candidateBounds) || !finiteBounds(referenceBounds)) {
    return false;
  }

  // A georeferenced viewport is strong evidence only when the raw UTM-like
  // coordinates physically intersect it. Merely being numerically close is
  // not enough because the same easting/northing values repeat in every zone.
  const overlapX =
    Math.min(candidateBounds.maxX, referenceBounds.maxX) -
    Math.max(candidateBounds.minX, referenceBounds.minX);
  const overlapY =
    Math.min(candidateBounds.maxY, referenceBounds.maxY) -
    Math.max(candidateBounds.minY, referenceBounds.minY);

  return overlapX >= 0 && overlapY >= 0;
}
